module.exports = __webpack_public_path__ + "img/Icon12_09.c31852df.svg";